module.exports = __webpack_public_path__ + "static/media/Data_insight_1-3.33747d42.svg";